module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/92de141c77ea10d16cf6d15e33e6c1ac.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_classes.svg
// module id = vwzQ
// module chunks = 0